import CompanyRegistrationsApp from './CompanyRegistrationsApp'
import React from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from "react-i18next";
import i18n from "@apps/Shared/translation/i18n";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

const container = document.getElementById('js-company-registrations')!;
const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
  <I18nextProvider i18n={i18n}>
    <QueryClientProvider client={queryClient}>
      <CompanyRegistrationsApp/>
    </QueryClientProvider>
  </I18nextProvider>
);